type AssignmentAvailability = {
  id: string;
  examId: string;
  status: string;
  timing: "untimed" | "timed";
};

export function activeAssignmentForExam<T extends AssignmentAvailability>(examId: string, assignments: T[]): T | null {
  return assignments.find((assignment) =>
    assignment.examId === examId
    && (assignment.status === "assigned" || assignment.status === "in_progress")
  ) ?? null;
}
